/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Slide from '@material-ui/core/Slide';
import DialogContent from '@material-ui/core/DialogContent';
import { Dialog, DialogTitle, DialogActions } from './styles';

const TransitionUp = forwardRef((props, ref) => <Slide direction="up" {...props} ref={ref} />);

const ActionDialog = ({
  open,
  title,
  maxWidth,
  buttonCopy,
  handleCancel,
  handleConfirm,
  children,
  isValid,
  ...rest
}) => (
  <Dialog
    fullWidth
    maxWidth={maxWidth}
    open={open}
    onClose={handleCancel}
    aria-labelledby="action-title"
    TransitionComponent={TransitionUp}
    {...rest}
  >
    <DialogTitle id="action-title" onClose={handleCancel}>
      {title}
    </DialogTitle>

    <DialogContent>{children}</DialogContent>

    <DialogActions>
      <Button disabled={!isValid} color="primary" onClick={handleConfirm}>
        {buttonCopy}
      </Button>
    </DialogActions>
  </Dialog>
);

ActionDialog.defaultProps = {
  open: false,
  title: 'Please confirm',
  maxWidth: 'sm',
  buttonCopy: 'Confirm',
  handleConfirm: () => false,
  isValid: false,
};

ActionDialog.propTypes = {
  isValid: PropTypes.bool,
  open: PropTypes.bool,
  title: PropTypes.string,
  maxWidth: PropTypes.string,
  buttonCopy: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ActionDialog;
